<template>
  <div class="blessingDiv">
    <div class="blessing">
      <img src="../../assets/image/btn_beijingb_nor.png" alt="背景图片" class="blessingImg" />
      <div class="input">
        <el-input type="textarea" placeholder="请输入祝福语+专业+年级" v-model="postData.msg" maxlength="100" show-word-limit>
        </el-input>
      </div>
      <div class="btnDiv" @click="submit">
        <img src="../../assets/image/btn_tijiao_nor.png" alt="提交" class="btn" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      postData: {
        msg: "",
        openId: localStorage.getItem("siginOpenid"),
        file: null
      }
    };
  },
  created() { },
  methods: {
    async submit() {
      const result = await this.$http({
        url: "/wx/enterbless",
        method: "POST",
        headers: { "content-type": "application/x-www-form-urlencoded" },
        data: this.$qs.stringify(
          this.postData
        ),
      });
      if (result.data.code == "101") {
        this.$toast("签到成功");
        return this.$router.push({
          path: "/takePhoto",
          query: { blessing: this.postData.msg },
        });
      } else {
        this.$toast(result.data.msg);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.blessing {
  position: relative;
  min-height: 100vh;

  .blessingImg {
    height: 100vh;
    width: 100%;
  }

  .input {
    position: absolute;
    top: 25%;
    left: 5%;
    width: 90%;
    height: 45%;

    /deep/.el-textarea {
      height: 100%;

      .el-textarea__inner {
        height: 100%;
        border-radius: 15px;
      }
    }
  }

  .btnDiv {
    width: 50%;
    position: absolute;
    left: 50%;
    top: 75%;
    transform: translateX(-50%);

    .btn {
      width: 100%;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/siginIn/Blessing.vue